module.exports = __webpack_public_path__ + "static/media/img_dating.fe8b0d8a.gif";